<!--
** 专家登录后--项目评估home
 -->


<template>
    <div id="home" class="apps">
        <el-container class="side-container">
            <el-aside class= "side" width="200px">
                <div>
                    <h1>安优查云平台</h1>
                </div>
                <el-menu
                :default-active="$route.path"
                router
                >
                    <el-submenu index="/personEval">
                        <template slot="title"><i class="el-icon-s-management"></i>项目评估</template>
                            <el-menu-item-group>
                                <el-menu-item index="/personEval/GoingProject">进行中项目</el-menu-item>
                                <el-menu-item index="/personEval/CompleteProject">已完成项目</el-menu-item>
                            </el-menu-item-group>
                    </el-submenu>
                </el-menu>
            </el-aside>
            <el-main class="main">
                <div class="main-top">
                    <div class="top-breadcrumb">
                        <el-breadcrumb separator="/">
                            <el-breadcrumb-item v-for="(item,index) of $route.matched" :key="index" >
                                <router-link :to="item.path" style="color:#000">{{item.meta.title}}</router-link>
                            </el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </div>
                <div class="main-view">
                     <router-view></router-view>
                </div>
                <div>
                    1235
                </div>
                <div id="userAvatar">
                    <el-dropdown >
                        <span class="el-dropdown-link">
                          <el-avatar shape="square" :size="35"  icon="el-icon-user-solid"></el-avatar>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item  ><span @click="dialogFormVisible = true">修改密码</span></el-dropdown-item>
                            <el-dropdown-item><span @click="exit">退出登录</span></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>

                 <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="20%" top="20vh">
                    <el-form :model="form">
                        <el-form-item label="原密码" >
                        <el-input v-model="form.name" autocomplete="off" show-password></el-input>
                        </el-form-item>
                                <el-form-item label="新密码" >
                        <el-input v-model="form.name" autocomplete="off" show-password></el-input>
                        </el-form-item>
                                <el-form-item label="确认密码" >
                        <el-input v-model="form.name" autocomplete="off" show-password></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisible = false">取 消</el-button>
                          <el-button type="primary" @click="dialogFormVisible=false">确 定</el-button>
                    </div>
                </el-dialog>
            </el-main>
        </el-container>
    </div>
</template>
<script>
export default {
    name:"ProjectEval",
    data(){
        return {
            sidebarItem:"",
            dialogFormVisible:false,
            form: {
                name: '',
                region: '',
                date1: '',
                date2: '',
                delivery: false,
                type: [],
                resource: '',
                desc: ''
            },
        }
    },
    watch:{
        '$route':'init'
    },
    mounted(){
        this.sidebarItem = this.$route.name;
        // console.log(this.$route.matched)
    },
    methods:{

        // handleMenuItemClick(name){
        //     console.log('name',name);
        //     this.$router.push({path:name});
        //     this.currentMenuIndex= name;
        // },
        init(){
            console.log(this.$route)
        },
        exit(){
            console.log('exit')
        },
    }
}
</script>
<style scoped>
.side-container {
    height:100vh;
    border: 1px solid #eee;
}
#home .el-aside {
    background-color: #e8e8e8;
}
#home >>> .el-menu{
    background-color: #e8e8e8;
}
#home >>> .el-submenu__title{
    color: #000;
}
/* 左边菜单选中时的样式 */
/* #home >>> .el-submenu.is-active .el-submenu__title {

    border-bottom-color:#bfbfbf
}*/
.el-menu-item.is-active{
  background-color: #bfbfbf;
    color: #000;
}
.main-top {
    height:40px;
    padding-top:18px;
    border-top:1px solid #ccc;
    padding-left:20px;
    margin-top:40px;
}
.el-main{
    padding:0px;
}
.el-submenu__title i{
    /* color: #909399; */
    color: #000;
}
#home >>> .el-submenu__icon-arrow{
    font-size: 14px;
}
.checklist.is-active {
    background-color:#bfbfbf !important;
    color: #000;
}
/* 登录状态样式 */
.main>>>.el-dialog__title{
    float: left;
}
 .main>>>.el-input__inner {
  height: 35px;
  /* padding: 0 10px; */
  border: 1px solid #409eff;
  width: 100%;
}
.el-avatar{
    background: #FFF;
}
.el-dropdown :hover{
    background: #C0C4CC;
}
#userAvatar{
    position: absolute;
    width: 40px;
    height: 40px;
    /* background: chartreuse; */
    top:5px;
    right: 35px;
}
.el-avatar--icon{
    font-size: 28px;
    color: #000;
}
</style>



// WEBPACK FOOTER //
// src/views/Expert/ProjectEval.vue